module.exports = __webpack_public_path__ + "img/empty-queue.a61345ab.svg";